export const serviceKeys = [
    "mortgage_pre_approval",
    "investment_property_loans",
    "home_equity_loans",
    "first_time_home_buyer_loans",
    "debt_consolidation",
    "custom_loan_solutions",
    "refinancing_services",
    "interest_rate_optimization",
    "construction_loans",
    "loan_application_assistance",
    "government_backed_loans",
    "reverse_mortgages",
    "credit_score_consultation",
  ];